import { CircularProgress } from '@mui/material'
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { getGitHubUrl } from '../../config/constant';
import { cloudServiceBaseUrl } from '../../config';

function Authenticator() {

  const signupWithGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      // console.log("success", tokenResponse);
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse?.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse?.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then(async (res) => {
          if (res?.data?.email) {
            window.location.href = `${queryParams?.refer}?auth=success&email=${res.data?.email}&given_name=${res.data?.given_name}&family_name=${res.data?.family_name}&phone=${res.data?.phone}`
            // await signupUser(
            //   res.data?.email,
            //   res.data?.given_name,
            //   res.data?.family_name,
            //   res.data?.phone
            // );
          }
        })
        .catch((err) => {
          window.location.href = `${queryParams?.refer}?auth=fail`
        });
    },
    onError: (tokenResponse) => {
      window.location.href = `${queryParams?.refer}?auth=fail`
    },
  });

  const [queryParams, setQueryParams] = useState({});
  const googleRef = useRef()

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of queryParams.entries()) {
      params[key] = value;
    }
    setQueryParams(params);
  }, []);

  useEffect(() => {
    if (queryParams?.provider === 'google') {
      if (googleRef?.current) {
        googleRef?.current?.click()
      }
    } else if (queryParams?.provider === 'github') {
      sessionStorage.setItem('redirect', queryParams.refer)
      window.location.assign(getGitHubUrl(window.location.pathname))
    }
  }, [queryParams.provider, queryParams.refer, googleRef?.current])

  const signinWithGithub = async (accessCode) => {
    try {
      const res = await axios.post(
        `https://${cloudServiceBaseUrl}/auth/github/get_access_token`,
        {
          code: accessCode,
        }
      );

      if (res?.data?.access_token) {
        // const profile = await axios.get(`https://api.github.com/user`, {
        //   headers: {
        //     Authorization: `Bearer ${res?.data?.access_token}`,
        //   },
        // });

        const emails = await axios.get(`https://api.github.com/user/emails`, {
          headers: {
            Authorization: `Bearer ${res?.data?.access_token}`,
          },
        });

        const primaryEmail = emails?.data?.find(
          (obj) => obj?.primary === true
        )?.email;

        if (primaryEmail) {
          const temp = sessionStorage.getItem('redirect')
          let prefix = temp
          let suffix = ''
          if (temp.includes('?')) {
            const test = temp.split('?')
            prefix = test?.[0]
            test.shift()
            const t = test.join('?')
            suffix = t ? `&${t}` : ''
            
          }
          window.location.href = `${prefix}?auth=success&email=${primaryEmail}&given_name=${primaryEmail}${suffix}`
        }
        setTimeout(() => {
          window.location.href = `${sessionStorage.getItem('redirect')}?auth=fail`
        }, 5000)
      }
    } catch (err) {
      // window.location.href = `${sessionStorage.getItem('redirect')}?auth=fail`
      console.log(err)
    }
  }
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  useEffect(() => {
    if (code && state) {
      signinWithGithub(code);
    }
  }, [code, state]);

  return (
    <div className='h-screen w-screen flex items-center justify-center'>
      <div className='flex items-center'>
        {
          queryParams?.provider === 'google' && (
            <div className="mt-6 grid grid-cols-2 gap-4">
              <button
                ref={googleRef}
                className="flex w-full items-center justify-center gap-3 rounded-md bg-white shadow-md border px-3 py-1.5 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1D9BF0] cursor-pointer"
                onClick={() => {
                  signupWithGoogle()
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="512"
                  height="512"
                  x="0"
                  y="0"
                  viewBox="0 0 512 512"
                  xmlSpace="preserve"
                  className="w-5 h-5"
                >
                  <g>
                    <path
                      d="m492.668 211.489-208.84-.01c-9.222 0-16.697 7.474-16.697 16.696v66.715c0 9.22 7.475 16.696 16.696 16.696h117.606c-12.878 33.421-36.914 61.41-67.58 79.194L384 477.589c80.442-46.523 128-128.152 128-219.53 0-13.011-.959-22.312-2.877-32.785-1.458-7.957-8.366-13.785-16.455-13.785z"
                      // style=""
                      fill="#167ee6"
                      data-original="#167ee6"
                    // class=""
                    ></path>
                    <path
                      d="M256 411.826c-57.554 0-107.798-31.446-134.783-77.979l-86.806 50.034C78.586 460.443 161.34 512 256 512c46.437 0 90.254-12.503 128-34.292v-.119l-50.147-86.81c-22.938 13.304-49.482 21.047-77.853 21.047z"
                      // style=""
                      fill="#12b347"
                      data-original="#12b347"
                    ></path>
                    <path
                      d="M384 477.708v-.119l-50.147-86.81c-22.938 13.303-49.48 21.047-77.853 21.047V512c46.437 0 90.256-12.503 128-34.292z"
                      // style=""
                      fill="#0f993e"
                      data-original="#0f993e"
                    ></path>
                    <path
                      d="M100.174 256c0-28.369 7.742-54.91 21.043-77.847l-86.806-50.034C12.502 165.746 0 209.444 0 256s12.502 90.254 34.411 127.881l86.806-50.034c-13.301-22.937-21.043-49.478-21.043-77.847z"
                      // style=""
                      fill="#ffd500"
                      data-original="#ffd500"
                    // class=""
                    ></path>
                    <path
                      d="M256 100.174c37.531 0 72.005 13.336 98.932 35.519 6.643 5.472 16.298 5.077 22.383-1.008l47.27-47.27c6.904-6.904 6.412-18.205-.963-24.603C378.507 23.673 319.807 0 256 0 161.34 0 78.586 51.557 34.411 128.119l86.806 50.034c26.985-46.533 77.229-77.979 134.783-77.979z"
                      // style=""
                      fill="#ff4b26"
                      data-original="#ff4b26"
                    ></path>
                    <path
                      d="M354.932 135.693c6.643 5.472 16.299 5.077 22.383-1.008l47.27-47.27c6.903-6.904 6.411-18.205-.963-24.603C378.507 23.672 319.807 0 256 0v100.174c37.53 0 72.005 13.336 98.932 35.519z"
                      // style=""
                      fill="#d93f21"
                      data-original="#d93f21"
                    ></path>
                  </g>
                </svg>
                <span className="text-sm font-semibold leading-6 text-black">
                  Google
                </span>
              </button>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default Authenticator
